import { render, staticRenderFns } from "./bonus_coupon_add.vue?vue&type=template&id=9c672c4c&"
import script from "./bonus_coupon_add.vue?vue&type=script&lang=js&"
export * from "./bonus_coupon_add.vue?vue&type=script&lang=js&"
import style0 from "./bonus_coupon_add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports